import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/data/isbn/[isbn]/components/isbn-tile.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/data/isbn/[isbn]/components/line-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/data/isbn/[isbn]/components/recent-sales.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/loadable-image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/typography/heading.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
